import React, { useState} from 'react';
import { Box, Dialog, DialogTitle, DialogContent, IconButton, Typography, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import YouSaid from './components/YouSaid';
import { useConfig, configKeys, serverUrl } from './ConfigHolder';
import HistoryTable from './HistoryTable';
import TwoState from './components/TwoState';
import { get_auth } from './auth';

// const lessIntenseYellow = 'hsl(50, 100%, 90%)';

const playFromStorage = (path) => {
  let uri = serverUrl + '/predefined_voice_file'
  let params = {path: path};
  get_auth(uri, params, 'json')
  .then(response => {
      const audio = new Audio(`data:audio/mp3;base64,${response.data.audio}`);
      audio.play();
  })
  .catch(error => {
      console.error('Predefined file error:', error);
  });
};

const DisplayTranscriptionResults = ({ imageURL, respArray, bestScore }) => {
  const { config } = useConfig();
  const [isExpanded, setIsExpanded] = useState(false);
  const tooltip = 'Left chart shows speech quality in your attempts. \nRight chart shows speech duration.\nHighlighted bars show the desired quality and duration';
  // I might need it later 2025-04-02
  // eslint-disable-next-line 
  const explanationInput = () => {
    const data = [...respArray];
    if (data.length === 0) return '';
    
    const last_result = data.pop();
    const lost = last_result['lost'];
    
    return lost === 'None' ? last_result['weak'].split(' ')[0] : lost;
  };
  
 
  return (
    <Box sx = {{display:'flex', flexDirection: 'column', 
                alignItems: 'flex-start', width :'100%',
                // keep these two lines for future use 2025-03-22
                // maxHeight:"40vh",
                // overflowY: 'auto',
                }}> 
      <Box sx = {{
                display:"flex",
                alignItems:"flex-start",
                flexDirection: "row",
                width: '100%',
                ml: 1,
                pr:2,
            }}>

        <HistoryTable in_data={respArray.slice(-1)} bestScore={bestScore} playFromStorage={playFromStorage}
                 langLearn={config[configKeys.langLearn].label}
                 langBase={config[configKeys.langBase].label}
                 explain = {true}
        
        />

        <Box sx = {{mt:4, ml:-1}} >

        </Box>
      </Box>
      <Box display="flex" alignItems="flex-start" mt={1}>

        <TwoState stateCallBack = {setIsExpanded}
                  initialState = {isExpanded}
                  nameKey = "resultsExpanded"
                  label = 'Attempts' >
                  </TwoState>

      </Box>
      {isExpanded && (
        <Box sx = {{ml:1, 
                    mr:10,
                   display: 'flex', 
                  //  alignItems: 'flex-start',
                  //  justifyContent : 'left', 
                   flexDirection:'column',
                   width:'100%',
                   pr:2,
                   }} >
          <HistoryTable 
                        // in_data={respArray.slice(0,-1)} 
                        in_data={respArray} 
                        bestScore={bestScore} 
                        playFromStorage={playFromStorage}
                        langLearn={config[configKeys.langLearn].label}
                        langBase={config[configKeys.langBase].label}
                        explain= {false}
                        showHeader = {true}
          />
          {/* <Box component="img" src={`data:image/png;base64,${imageURL}`} width={width} sx={{ p: 1 }} alt="quality" title={tooltip} /> */}
          
         { imageURL ? 
            (<Box sx = {{alignItems:'flex-start', width:'100%'}}>
                <Box component="img" src={`data:image/png;base64,${imageURL}`}  
                sx={{ pt:1, 
                  width: '80%', 
                  // hight:'auto', 
                  alignItems:'flex-start'
                  // margin: '0 auto' 
                }} 
                  alt="quality" title={tooltip} 
                />

              </Box>
            ) 
            : null
          }
        </Box>
      )}
    </Box>
  );
};

const FormResults = ({ isModalOpen, transcription, qualityImage, responseArray, bestScore, onClose, onHide }) => {

  const { config } = useConfig();

  const handleHideCheck = (event) => {
    if (onHide) {
      onHide(true);
    }
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={onClose}
      // maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          // backgroundColor: 'seashell',
          backgroundColor: 'lavender', 
          borderRadius: 2,
        }
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', 
        alignItems: 'center', 
        mb:1, 
        mt:1,
        maxHeight:36,
        ml:1,
        
        }}>
        <Typography variant="body1" sx ={{fontWeight: 'bold'}} >Transcription Results</Typography>
        <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-end" // Align everything to the right
            sx={{ mt: 1, mb: 1 }}
          >

          <Tooltip title="Hide this form. If you need it again, reload this page.">
            <IconButton
              onClick={handleHideCheck}
              sx={{ color: 'inherit' }} // Optional: Customize the color as needed
            >
              <VisibilityOffIcon />
            </IconButton>
          </Tooltip>
         <IconButton onClick={onClose} size="small">
           <CloseIcon />
         </IconButton>         
        </Box>


 
      </DialogTitle>
      <DialogContent 
        // dividers 
        
      >
      <Box sx = {{mt:1}} >
        <YouSaid 
          value={transcription} 
          lang = {config[configKeys.langLearn].label}
        />
      </Box>
        <DisplayTranscriptionResults imageURL={qualityImage} respArray={responseArray} bestScore={bestScore} />
      </DialogContent>
    </Dialog>
  );
};

export { DisplayTranscriptionResults, FormResults, playFromStorage };
